var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoomIn(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE6\x94\xBE\xE5\xA4\xA7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 4233",
    d: "M11.8229 12.1345L13.3894 13.9517",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2468",
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.30005 5.54999C8.30005 5.13577 7.96426 4.79999 7.55005 4.79999C7.13584 4.79999 6.80005 5.13577 6.80005 5.54999L6.80005 6.79999H5.55005C5.13584 6.79999 4.80005 7.13577 4.80005 7.54999C4.80005 7.9642 5.13584 8.29999 5.55005 8.29999H6.80005L6.80005 9.54999C6.80005 9.9642 7.13583 10.3 7.55005 10.3C7.96426 10.3 8.30005 9.9642 8.30005 9.54999V8.29999H9.55005C9.96426 8.29999 10.3 7.9642 10.3 7.54999C10.3 7.13577 9.96426 6.79999 9.55005 6.79999H8.30005V5.54999Z",
    fill: "#333333"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/zoomIn.3c617ea52eff117fdad8e4348b98a03f.svg";
export { ForwardRef as ReactComponent };